module.exports = __webpack_public_path__ + "img/vehicle-options-black-lincoln.cb1d0ad7.png";